import routes from './routes';

import agUserManagementMain from './views/agUserManagementMain.component';
import * as shareholderViews from './views/shareholders/componentRegistration';

export default angular
  .module('agentUserManagement', [])
  .config(routes)
  .component({
    agUserManagementMain,
    ...shareholderViews,
  });
